import { Injectable } from "@angular/core";
import { ApiService } from "@youm-front/api/data-access";
import { map, Observable } from "rxjs";
import {
  RoomMixerStreamGetRequestDTO,
  RoomMixerStreamGetResponseDTO,
  RoomMixerStreamGetResponseDTORaw
} from "../dto";

@Injectable()
export class RoomMixerService {
  constructor(private readonly apiService: ApiService) {}

  roomMixerStreamGet(
    req: RoomMixerStreamGetRequestDTO
  ): Observable<RoomMixerStreamGetResponseDTO> {
    const { roomId } = req.value;

    return this.apiService
      .get<RoomMixerStreamGetResponseDTORaw>(`rooms/${roomId}/mixer-stream`)
      .pipe(map((_) => new RoomMixerStreamGetResponseDTO(_)));
  }
}
